import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './routes/HomePage';
import AiChatPage from './routes/AiChatPage';
import TrainingHome from './routes/training/TrainingHome';
import LessonPage from './routes/training/LessonPage';
import QuizPage from './routes/training/QuizPage';
import SearchPage from './routes/training/SearchPage';
import ArticlePage from './routes/training/ArticlePage';
import BookmarksPage from './routes/training/BookmarksPage';
import ContentStudioPage from './routes/ContentStudioPage';
import PhotoStudioPage from './routes/PhotoStudioPage';
import CabinetPage from './routes/CabinetPage';
import AdminUsersPage from './routes/admin/AdminUsersPage';
import AdminUserDetailPage from './routes/admin/AdminUserDetailPage';
import AdminContentPage from './routes/admin/AdminContentPage';
import AdminFalBalancePage from './routes/admin/AdminFalBalancePage';
import AdminSettingsPage from './routes/admin/AdminSettingsPage';
import AdminPromptsPage from './routes/admin/AdminPromptsPage';
import ShiftsPage from './routes/ShiftsPage';
import ExpiryPage from './routes/ExpiryPage';
import { RequireRole } from './components/RequireRole';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/ai" element={<AiChatPage />} />

      {/* Training — доступно всем активным ролям */}
      <Route path="/training" element={<TrainingHome />} />
      <Route path="/training/search" element={<SearchPage />} />
      <Route path="/training/bookmarks" element={<BookmarksPage />} />
      <Route path="/training/lesson/:id" element={<LessonPage />} />
      <Route path="/training/lesson/:id/quiz" element={<QuizPage />} />
      <Route path="/training/article/:id" element={<ArticlePage />} />

      {/* Studios — только admin + consultant */}
      <Route
        path="/content"
        element={
          <RequireRole allow={['admin', 'consultant']}>
            <ContentStudioPage />
          </RequireRole>
        }
      />
      <Route
        path="/photo"
        element={
          <RequireRole allow={['admin', 'consultant']}>
            <PhotoStudioPage />
          </RequireRole>
        }
      />

      <Route path="/cabinet" element={<CabinetPage />} />

      <Route
        path="/shifts"
        element={
          <RequireRole allow={['admin', 'consultant']}>
            <ShiftsPage />
          </RequireRole>
        }
      />
      <Route
        path="/expiry"
        element={
          <RequireRole allow={['admin', 'consultant']}>
            <ExpiryPage />
          </RequireRole>
        }
      />

      {/* Admin — только admin */}
      <Route path="/admin" element={<Navigate to="/admin/users" replace />} />
      <Route
        path="/admin/users"
        element={
          <RequireRole allow={['admin']}>
            <AdminUsersPage />
          </RequireRole>
        }
      />
      <Route
        path="/admin/users/:id"
        element={
          <RequireRole allow={['admin']}>
            <AdminUserDetailPage />
          </RequireRole>
        }
      />
      <Route
        path="/admin/content"
        element={
          <RequireRole allow={['admin']}>
            <AdminContentPage />
          </RequireRole>
        }
      />
      <Route
        path="/admin/fal-balance"
        element={
          <RequireRole allow={['admin']}>
            <AdminFalBalancePage />
          </RequireRole>
        }
      />
      <Route
        path="/admin/settings"
        element={
          <RequireRole allow={['admin']}>
            <AdminSettingsPage />
          </RequireRole>
        }
      />
      <Route
        path="/admin/prompts"
        element={
          <RequireRole allow={['admin']}>
            <AdminPromptsPage />
          </RequireRole>
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
